export default __webpack_public_path__ + "static/media/cart.e23d422e.svg";